Vue.component('MpLeaderCard', {
    props: {
        leaderData: {
            type: Object,
            default: function () {
                return '';
            }
        },
        highlight: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        social: {
            type: Boolean,
            default: function () {
                return true;
            }
        },
        moreLink: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        shareFbTitle: {
            type: String,
            default: ''
        },
        shareTwTitle: {
            type: String,
            default: ''
        },
        shareLiTitle: {
            type: String,
            default: ''
        },
        detailLabel: {
            type: String,
            default: ''
        },
        contactLabel: {
            type: String,
            default: ''
        },
        webLabel: {
            type: String,
            default: ''
        },
        moreTitle: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            SHARE_SOURCE_FACEBOOK: 'fb',
            SHARE_SOURCE_TWITTER: 'tw',
            SHARE_SOURCE_LINKEDIN: 'li',

            company: '',
            logo: '',
            resume: '',
            category: '',
            order: 999,
            link: '',
            shareUrl: '',
            shareTitle: '',
            visible: false,
        };
    },

    computed: {

    },

    methods: {

        goToDetail: function(ev) {
            if (ev.target.className.indexOf('btn') >= 0) {
                return;
            }

            window.location = this.leaderData.link;
        },

        getContactUrl: function() {
            return '/equipment/contact/tk/' + this.leaderData.id;
        },

        getShareUrl: function(source) {

            switch (source) {
                case this.SHARE_SOURCE_FACEBOOK:    return 'https://www.facebook.com/sharer/sharer.php?u=' + this.shareUrl;
                case this.SHARE_SOURCE_TWITTER:     return 'https://twitter.com/intent/tweet?url=' + this.shareUrl + '&amp;text=' + this.shareTitle;
                case this.SHARE_SOURCE_LINKEDIN:    return 'https://www.linkedin.com/shareArticle?url=' + this.shareUrl + '&amp;title=' + this.shareTitle + '&amp;source=MundoPetróleo';
            }
        },

        getAppLink: function(source) {

            switch (source) {
                case this.SHARE_SOURCE_FACEBOOK:    return 'fb://feed?link' + this.shareUrl + '&amp;message=' + this.shareTitle;
                case this.SHARE_SOURCE_TWITTER:     return 'twitter://post?url=' + this.shareUrl + '&amp;text=' + this.shareTitle;
            }
        },
    },

    template: '\
    <div>\
        <article class="services-card" :class="{ \'services-card--highlight\': highlight }">\
            <div class="services-card__inner" :class="{ \'u-pb-xxl\': moreLink }">\
                <a class="services-card__inner-link" :href="leaderData.link" @click.prevent="goToDetail">\
                    <h3 class="services-card__media">\
                        <img class="services-card__media-img" :src="leaderData.logo" v-if="leaderData.logo" />\
                        <span class="services-card__media-text u-sr-only">{{ leaderData.company }}</span>\
                    </h3>\
                    <h3 class="services-card__company">{{ leaderData.company }}</h3>\
                    <p class="services-card__text" v-html="$options.filters.trimText(leaderData.resume, 148)"></p>\
                </a>\
                <div class="services-card__contact" v-if="highlight">\
                    <a class="btn btn--md" :href="leaderData.link">{{ detailLabel}}</a>\
                    <a class="btn btn--tertiary btn--md" :href="getContactUrl()">{{ contactLabel}}</a>\
                    <a class="btn-link" :href="leaderData.web" target="_blank">\
                        <span class="btn-link__icon icon">\
                            <svg class="icon__inner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 16.5h-3a4.5 4.5 0 110-9h3M14.25 7.5h3a4.5 4.5 0 110 9h-3M7.654 12h8.786" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\
                        </span>\
                        <span class="btn-link__label">{{ webLabel }}</span>\
                    </a>\
                </div>\
            </div>\
            \
            <div class="services-card__social" v-if="social">\
                <ul class="services-card__social-list">\
                    <li class="services-card__social-item">\
                        <a class="services-card__social-link services-card__social-link--more" :href="leaderData.link">\
                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="nonzero"><path d="M15 0C6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15S23.27 0 15 0zm0 29.5C7.005 29.5.5 22.995.5 15S7.005.5 15 .5 29.5 7.005 29.5 15 22.995 29.5 15 29.5z"/><path d="M7.5 18c1.379 0 2.5-1.121 2.5-2.5S8.879 13 7.5 13A2.503 2.503 0 005 15.5C5 16.879 6.121 18 7.5 18zm0-4.167c.92 0 1.667.748 1.667 1.667 0 .92-.748 1.667-1.667 1.667-.92 0-1.667-.748-1.667-1.667 0-.92.748-1.667 1.667-1.667zM12.5 15.5c0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5S16.379 13 15 13a2.503 2.503 0 00-2.5 2.5zm4.167 0c0 .92-.748 1.667-1.667 1.667-.92 0-1.667-.748-1.667-1.667 0-.92.748-1.667 1.667-1.667.92 0 1.667.748 1.667 1.667zM22.5 13a2.503 2.503 0 00-2.5 2.5c0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5zm0 4.167c-.92 0-1.667-.748-1.667-1.667 0-.92.748-1.667 1.667-1.667.92 0 1.667.748 1.667 1.667 0 .92-.748 1.667-1.667 1.667z"/></g></svg>\
                        </a>\
                    </li>\
                    <li class="services-card__social-item">\
                        <a class="services-card__social-link services-card__social-link--facebook" :href="getShareUrl(SHARE_SOURCE_FACEBOOK)" :data-applink="getAppLink(SHARE_SOURCE_FACEBOOK)" title="shareFbTitle" rel="nofollow">\
                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="nonzero"><path d="M15 0C6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15S23.27 0 15 0zm0 29.5C7.005 29.5.5 22.995.5 15S7.005.5 15 .5 29.5 7.005 29.5 15 22.995 29.5 15 29.5z"/><path d="M16.333 12.333v-1.587c0-.717.159-1.08 1.271-1.08H19V7h-2.33c-2.853 0-3.795 1.308-3.795 3.554v1.78H11V15h1.875v8h3.458v-8h2.35L19 12.333h-2.667zm1.759 2h-2.425v8h-2.125v-8h-1.875V13h1.874V10.554c0-1.02.226-1.716.647-2.158.466-.5 1.295-.73 2.483-.73h1.662V9h-.729c-.5 0-1.146.046-1.546.488-.337.375-.391.837-.391 1.254V13h2.583l-.158 1.333z"/></g></svg>\
                        </a>\
                    </li>\
                    <li class="services-card__social-item">\
                        <a class="services-card__social-link services-card__social-link--twitter" :href="getShareUrl(SHARE_SOURCE_TWITTER)" :data-applink="getAppLink(SHARE_SOURCE_TWITTER)" title="shareTwTitle" rel="nofollow">\
                            <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" d="M26.601 5.393A14.976 14.976 0 0 0 15.998 1 14.974 14.974 0 0 0 5.395 5.393a14.959 14.959 0 0 0-4.393 10.611c0 4.135 1.677 7.889 4.393 10.603A14.973 14.973 0 0 0 15.998 31c4.143 0 7.888-1.686 10.603-4.393a14.954 14.954 0 0 0 4.393-10.603A14.96 14.96 0 0 0 26.6 5.392Zm-.83 20.384a13.78 13.78 0 0 1-9.773 4.052 13.78 13.78 0 0 1-9.773-4.052 13.762 13.762 0 0 1-4.052-9.773c0-3.82 1.544-7.282 4.052-9.781 2.5-2.5 5.953-4.044 9.773-4.044 3.82 0 7.273 1.544 9.773 4.044a13.765 13.765 0 0 1 4.052 9.781 13.76 13.76 0 0 1-4.052 9.773Z" clip-rule="evenodd" /><path fill="currentColor" d="m8.039 9 6.177 8.26L8 23.975h1.4l5.442-5.88 4.397 5.88H24l-6.525-8.724L23.26 9h-1.4l-5.011 5.415L12.8 9H8.039Zm2.058 1.03h2.187l9.658 12.915h-2.187L10.097 10.03Z" /></svg>\
                        </a>\
                    </li>\
                    <li class="services-card__social-item">\
                        <a class="services-card__social-link services-card__social-link--linkedin" :href="getShareUrl(SHARE_SOURCE_LINKEDIN)" data-applink title="shareLiTitle" rel="nofollow">\
                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fill-rule="nonzero"><path d="M15 0C6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15S23.27 0 15 0zm0 29.5C7.005 29.5.5 22.995.5 15S7.005.5 15 .5 29.5 7.005 29.5 15 22.995 29.5 15 29.5z"/><path d="M22.985 22.68h-4.778v-5.41c0-1.281-.416-1.281-.594-1.281-.707 0-.784.912-.784 1.304v5.387h-4.304V12.664h4.272c.52-.314 1.223-.488 2.004-.488.5 0 1.762.092 2.677.946.973.906 1.507 2.307 1.507 3.943v5.615zm-4.262-.517h3.746v-5.098c0-1.491-.478-2.758-1.344-3.565-.781-.729-1.886-.807-2.324-.807-.875 0-1.624.237-2.05.652l-.438.425v-.59l-3.272.013v8.97h3.272v-4.87c0-1.141.486-1.822 1.3-1.822.747 0 1.11.588 1.11 1.798v4.894zm-6.93.517H7.015V12.664h4.778V22.68zm-4.262-.517h3.745V13.18l-3.745.012v8.97zm1.872-10.064a2.392 2.392 0 01-2.388-2.39 2.391 2.391 0 012.388-2.388 2.391 2.391 0 012.389 2.388 2.39 2.39 0 01-2.389 2.39zm0-4.262c-1.032 0-1.872.84-1.872 1.872 0 1.033.84 1.874 1.872 1.874 1.033 0 1.873-.84 1.873-1.874 0-1.032-.84-1.872-1.873-1.872z"/></g></svg>\
                        </a>\
                    </li>\
                </ul>\
            </div>\
            \
            <div class="services-card__more" v-if="moreLink">\
                <a class="btn-link btn-link--md btn-link--link" :href="leaderData.link">\
                    <span class="btn-link__label">{{ moreTitle }}</span>\
                    <span class="btn-link__icon icon icon--sm">\
                        <svg class="icon__inner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.563 5.25l6.75 6.75-6.75 6.75M18.375 12H4.687" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\
                    </span>\
                </a>\
            </div>\
        </article>\
    </div>',
});